import { Api } from '@/utils/Api'
import setEntities from '@/utils/SetEntities'
import UrlStore from '@/utils/UrlStore'
import { normalize, schema } from 'normalizr'
import Vue from 'vue'

export const EMPLOYEES_LOAD = 'EMPLOYEES_LOAD'
export const EMPLOYEE_LOAD = 'EMPLOYEE_LOAD'
export const EMPLOYEE_CREATE = 'EMPLOYEE_CREATE'
export const EMPLOYEE_UPDATE = 'EMPLOYEE_UPDATE'
export const EMPLOYEE_DESTROY = 'EMPLOYEE_DESTROY'
export const EMPLOYEE_STATE_UPDATE = 'EMPLOYEE_STATE_UPDATE'

const employeesApi = new Api(UrlStore.EMPLOYEES)
const employeeSchema = new schema.Entity('employees')

export const extractEmployees = (context, items) => {
  let employees = []
  items.forEach((item) => {
    if (item.employee) {
      employees.push(item.employee)
      item.employee = item.employee.id
    }
  })
  employees.length && context.commit('employee/' + EMPLOYEES_LOAD, { items: employees }, { root: true })
}

export default {
  namespaced: true,
  state: {
    employeesLoaded: false,
    employeesList: [],
    employeesPager: {},
    entities: {
      employees: {}
    }
  },
  getters: {
    employees(state) {
      return state.employeesList.map((bId) => state.entities.employees[bId])
    },
    getEmployee: (state) => (employeeId) => state.entities.employees[employeeId] || null
  },
  mutations: {
    [EMPLOYEES_LOAD](state, payload) {
      let normData = normalize(payload.items, [employeeSchema])
      state.employeesList = normData.result
      state.employeesPager = payload.pager
      setEntities(state, normData)
    },
    [EMPLOYEE_LOAD](state, payload) {
      let normData = normalize(payload, employeeSchema)
      setEntities(state, normData)
    },
    [EMPLOYEE_CREATE](state, employee) {
      state.employeesList.unshift(employee.id)
      Vue.set(state.entities.employees, employee.id, employee)
    },
    [EMPLOYEE_UPDATE](state, employee) {
      if (employee.id && state.entities.employees[employee.id]) {
        state.entities.employees[employee.id] = Object.assign({}, state.entities.employees[employee.id], employee)
      }
    },
    [EMPLOYEE_DESTROY](state, employee) {
      let num = state.employeesList.findIndex((cId) => cId === employee.id)
      if (num !== -1) {
        state.employeesList.splice(num, 1)
        delete state.entities.employees[employee.id]
      }
    },
    [EMPLOYEE_STATE_UPDATE](state, data) {
      for (let name of Object.keys(data)) {
        state[name] = data[name]
      }
    }
  },
  actions: {
    // just load data and return, like desk/deskEventsSearch: pickers page through their own
    // results and must not overwrite employeesList
    employeesSearch(_, config) {
      return employeesApi.getAll(config)
    },
    employeesLoad({ commit }, config = {}) {
      return employeesApi.getAll(config).then((r) => {
        if (r.data.items.length) {
          const desks = []
          r.data.items.forEach((item) => {
            if (item.events) {
              item.events.forEach((event) => {
                if (event.desk) {
                  desks.push(event.desk)
                }
              })
            }
          })
        }

        commit(EMPLOYEES_LOAD, r.data)
        commit(EMPLOYEE_STATE_UPDATE, { employeesLoaded: true })
      })
    },
    employeeLoad({ commit }, config) {
      return employeesApi.get({ id: config.id, config: config }).then((r) => {
        if (r.data.events) {
          const desks = []
          r.data.events.forEach((event) => {
            if (event.desk) {
              desks.push(event.desk)
            }
          })
        }
        commit(EMPLOYEE_LOAD, r.data)
      })
    },
    employeeSave({ commit, getters }, { employee, config = {} }) {
      if (!employee.id) throw new Error('Employee id is not present in `employeeSave`!')
      commit(getters.getEmployee(employee.id) ? EMPLOYEE_UPDATE : EMPLOYEE_CREATE, employee)
      const employeeUpdated = getters.getEmployee(employee.id)

      return employeesApi.save(employeeUpdated, config).then((r) => {
        if (r._isNew) {
          commit(EMPLOYEE_DESTROY, employeeUpdated) // local
          commit(EMPLOYEE_CREATE, r.data)
          if (r.data.point_id) {
            commit(`point/POINT_UPDATE`, { id: r.data.point_id, employee: r.data.id }, { root: true })
          }
        } else {
          commit(EMPLOYEE_UPDATE, r.data)
        }

        return r.data.id
      })
    },
    employeeDestroy({ commit }, { employee, config = {} }) {
      return employeesApi.destroy({ id: employee.id, config }).then(() => {
        commit(EMPLOYEE_DESTROY, employee)
      })
    }
  }
}
